import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

const isRemovalDelay = (value: unknown): value is number =>
	typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= 2147483647;

type MacroHeightPresets = {
	minHeight: Record<string, number>;
	presetHeight: Record<string, number>;
	minHeightRemoval: number;
	presetHeightRemoval: number;
};

/** Height maps are trusted configuration; invalid removal delays default to zero. */
export const readMacroPresetConfig = (): MacroHeightPresets | undefined => {
	try {
		const parsed: unknown = JSON.parse(
			StatsigConfigurations.getString('confluence_macro_preset_height', ''),
		);
		if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return undefined;

		const { minHeight, presetHeight, minHeightRemoval, presetHeightRemoval } =
			parsed as Partial<MacroHeightPresets>;
		if (minHeight === undefined && presetHeight === undefined) return undefined;

		return {
			minHeight: minHeight ?? {},
			presetHeight: presetHeight ?? {},
			minHeightRemoval: isRemovalDelay(minHeightRemoval) ? minHeightRemoval : 0,
			presetHeightRemoval: isRemovalDelay(presetHeightRemoval) ? presetHeightRemoval : 0,
		};
	} catch {
		return undefined;
	}
};
